import { ReactNode } from 'react';
import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

import html2canvas from 'html2canvas';

// Хук useGenerateImageFromElement использовать для получения png изображения React компонента.
// Нужно убедиться что компонент не содержит паддингов, иначе эти паддинги займут место и в изображении.
// const [portal, uriString] = useGenerateImageFromElement(<YourComponent />);
// Хук принимает один аргумент – React ноду,
// и возвращает массив из двух элементов, портал для монтирования в DOM и uri строку полученного png изображения.
// Портал нужно вмонтировать внутри React дерева просто указав {portal}, а uri строку передать в pdf компонент и использовать в <Image src={chartExampleImgSrc} />.

const root = document.getElementById('root');

export const useGenerateImageFromElement = (node: ReactNode) => {
  const [element, setElement] = useState<HTMLElement | null>();
  const [imgSrc, setImgSrc] = useState('');

  useEffect(() => {
    const div = document.createElement('div');
    div.id = Date.now().toString();
    div.className = 'pdf-elements-draw-container';
    root?.appendChild(div);
    setElement(div);
  }, []);

  useEffect(() => {
    if (element?.children[0]) {
      setTimeout(() => {
        html2canvas(element, {
          scale: 4,
        }).then((canvas: HTMLCanvasElement) => {
          const dataUri = canvas.toDataURL('image/png');
          setImgSrc(dataUri);
          root?.removeChild(element);
          setElement(null);
        });
      }, 1000)
    }
  }, [element]);

  return [element ? createPortal(node, element) : null, imgSrc] as const;
};
